<template>
    <button type="button" @click="submit"><slot/></button>
</template>

<script setup>
import axios from 'axios'
import { inject } from 'vue'

let props = defineProps(['action']);
let notyf = inject('notyf')

function submit(e) {
    axios.post(props.action)
        .then(response => {
            if (response.status == 201) {
                notyf.success('Cloning Project...');
            }
        })
        .catch(error => {
            notyf.error('Error requesting to clone markup')
        })
}
</script>
